const labelFields = {
  'config.labels': {
    label: 'Labels',
    defaultValue: [],
    placeholder: 'Apply labels to this test...'
  }
};

export { labelFields };
